import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ImagePlaceholder = (props: SvgIconProps) => (
    <SvgIcon width="56" height="56" viewBox="0 0 56 56" {...props} fill="none">
        <circle
            cx="19"
            cy="14"
            r="5.25"
            stroke={props.htmlColor || '#DEDFE0'}
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
        />
        <path
            d="M 14.4026,28.342 13.8868,27.8314 13.3596,28.3301 0.75,40.2581 V 4 C 0.75,2.20507 2.20507,0.75 4,0.75 h 48 c 1.7949,0 3.25,1.45508 3.25,3.25 V 39.6936 L 42.6066,22.3089 42.0483,21.5412 41.4306,22.2619 26.295,42.2249 Z M 55.25,39.6936 V 52 c 0,1.7949 -1.4551,3.25 -3.25,3.25 H 4 C 2.20508,55.25 0.75,53.7949 0.75,52 V 40.2581 L 13.8868,27.8314 25.7224,41.658 26.295,42.2249 26.8194,41.6131 42.0483,21.5412 Z"
            stroke={props.htmlColor || '#DEDFE0'}
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
        />
    </SvgIcon>
);
